const LabelTextToTestIdMap: Record<string, string> = {
  'Проверено Циан': 'VerifiedByCianLabel',
};

export const mapLabelTextToTestId = (text: string) => {
  return LabelTextToTestIdMap[text];
};
